import {
  CHANGE_SEMANTIC_FAILURE,
  CHANGE_SEMANTIC_REQUEST,
  CHANGE_SEMANTIC_SUCCESS,
  GET_SEMANTIC_FAILURE,
  GET_SEMANTIC_REQUEST,
  GET_SEMANTIC_SUCCESS,
  SemanticAction,
  SemanticState,
  STOP_TRIGGER_SYNC_SEMANTIC,
  TRIGGER_SYNC_SEMANTIC
} from 'stores/flow-type/semantic.type';

const initialState: SemanticState = {
  updateSubmitting: false,
  settingGetting: false,
  success: false,
  settings: {},
  checkSyncSemantic: 0
};

const semanticReducers = (state: SemanticState = initialState, action: SemanticAction) => {
  switch (action.type) {
    case GET_SEMANTIC_REQUEST:
      return { ...state, settingGetting: true };
    case GET_SEMANTIC_SUCCESS: {
      return {
        ...state,
        settingGetting: false,
        settings: action.payload.settings,
        error: undefined
      };
    }
    case GET_SEMANTIC_FAILURE:
      return {
        ...state,
        settingGetting: false,
        error: action.payload
      };
    case CHANGE_SEMANTIC_REQUEST:
      return { ...state, updateSubmitting: true, success: false };
    case CHANGE_SEMANTIC_SUCCESS: {
      return {
        ...state,
        updateSubmitting: false,
        success: true,
        settings: action.payload.settings,
        error: undefined
      };
    }
    case CHANGE_SEMANTIC_FAILURE:
      return {
        ...state,
        updateSubmitting: false,
        success: false,
        error: action.payload
      };
    case TRIGGER_SYNC_SEMANTIC:
      return {
        ...state,
        checkSyncSemantic: state.checkSyncSemantic < 10 ? state.checkSyncSemantic + 1 : 0
      };
    case STOP_TRIGGER_SYNC_SEMANTIC:
      return {
        ...state,
        checkSyncSemantic: 0
      };
    default:
      return state;
  }
};
export default semanticReducers;
